function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'color-swatches': '','red': 'rgb(239, 0, 0)','blue': 'rgb(0, 0, 238)','sand': 'rgb(203, 189, 147)','natural': 'rgb(214, 210, 196)','ice-gray': 'rgb(215, 210, 203)','sport-grey': 'rgb(153, 152, 155)','charcoal': 'rgb(102, 103, 108)','dark-heather': 'rgb(66, 85, 99)','turf-green': 'rgb(0, 122, 62)','irish-green': 'rgb(0, 167, 74)','graphite-heather': 'rgb(158, 162, 162)','soft-pink': 'rgb(248, 163, 188)','athletic-heather': 'rgb(151, 153, 155)','military-green': 'rgb(94, 116, 97)','soft-cream': 'rgb(244, 209, 161)','aqua': 'rgb(77, 135, 175)','light-blue': 'rgb(164, 200, 225)','heather-indigo': 'rgb(77, 105, 149)','light-pink': 'rgb(228, 198, 212)','heather-navy': 'rgb(51, 63, 72)','navy': 'rgb(51, 63, 72)','deep-heather': 'rgb(63, 68, 67)','orange': 'rgb(210, 96, 56)','heather-olive': 'rgb(74, 65, 42)','asphalt': 'rgb(83, 86, 90)','charity-pink': 'rgb(248, 163, 188)','tweed': 'rgb(99, 102, 106)','bay': 'rgb(107, 174, 135)','yam': 'rgb(208, 137, 63)','heather-peach': 'rgb(243, 190, 141)','heather-green': 'rgb(122, 135, 104)','forest-green': 'rgb(48, 69, 41)','blue-jean': 'rgb(111, 143, 175)','blue-spruce': 'rgb(81, 113, 110)','light-green': 'rgb(103, 153, 141)','pepper': 'rgb(113, 124, 134)','watermelon': 'rgb(231, 105, 102)','terracotta': 'rgb(226, 124, 98)','oatmeal-heather': 'rgb(231, 227, 214)','pale-pink': 'rgb(249, 233, 230)','heather-dust': 'rgb(216, 204, 181)','citron': 'rgb(228, 233, 197)','heather-tan': 'rgb(159, 123, 73)','heather-yellow-gold': 'rgb(227, 183, 80)','heather-military-green': 'rgb(91, 103, 80)','butter': 'rgb(251, 230, 161)','peachy': 'rgb(252, 177, 152)','dark-grey-heather': 'rgb(70, 78, 81)','royal': 'rgb(44, 70, 151)','tropical-blue': 'rgb(82, 181, 213)','blossom': 'rgb(249, 183, 255)','moss': 'rgb(138, 154, 91)','natural': 'rgb(253, 250, 246)','iron-grey': 'rgb(77, 84, 88)','atomic-blue': 'rgb(0, 137, 185)','true-navy': 'rgb(0, 0, 128)','island-reef': 'rgb(4, 248, 215)','blossom': 'rgb(240, 139, 175)','chambray': 'rgb(6, 255, 255)','graphite': 'rgb(79, 85, 91)','granite': 'rgb(117, 116, 124)','light-green': 'rgb(144, 238, 144)','pepper': 'rgb(60, 56, 40)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
